import Request from "@/common/net/request.js";
const request = new Request();
// 订单找车 订单列表获取列表
export function getDispatchOrderPage(data) {
  return request.send({
    url: `/pmy/freight/order/dispatch/dispatch/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 派单
export function dispatchOrderToDriver(data) {
  return request.send({
    url: `/pmy/freight/order/dispatch/allocate`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

export function downloadTable(data) {
  return request.send({
    url: `/joker/order/export`,
    method: "post",
    data,
    config: {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 导航测算
export function handleNavigationCalculation(data) {
  return request.send({
    url: `/joker/order/config/bargaining`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
export function setTimeout(data) {
  return request.send({
    url: `/joker/order/config/bargaining`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
//认领
export function claimDriver(data) {
  return request.send({
    url: `/pmy/sys/driver/claim`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
//调度设置司机状态
export function driverStatus(data) {
  return request.send({
    url: `/pmy/sys/driver/dispatch/driver-status`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
//认领列表
export function claimDriverPage(data) {
  return request.send({
    url: `/pmy/sys/driver/claim/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
//取消认领
export function claimDriverCancel(data) {
  return request.send({
    url: `/pmy/sys/driver/claim/cancel`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

export function getTimeout() {
  return request.send({
    url: `/joker/order/config/bargaining`,
    method: "get",
  });
}

export function getDriverCurrentOrder(driverId) {
  return request.send({
    url: `/pmy/freight/order/freight/driver/doing?driverId=${driverId}`,
    method: "get",
  });
}
